export var TIME_TO_ENTER_MODAL = 500;
export var TIME_TO_EXIT_MODAL = 500;
export var TIME_TO_HOLD_MODAL = 5000;
export var notificationStatus = {
    success: 'success',
    error: 'error',
    warning: 'warning',
};
export var noop = function () { };
